import { render, staticRenderFns } from "./FullCalendarDayCell.vue?vue&type=template&id=2c1ccb56"
import script from "./FullCalendarDayCell.vue?vue&type=script&lang=js"
export * from "./FullCalendarDayCell.vue?vue&type=script&lang=js"
import style0 from "./FullCalendarDayCell.vue?vue&type=style&index=0&id=2c1ccb56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports